/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConsolidadoGeneralMLS } from './consolidadoGeneralMLS';
import { ConsolidadoMensajesMLS } from './consolidadoMensajesMLS';
import { ConsolidadoTransferenciaMLS } from './consolidadoTransferenciaMLS';

export interface ObtenerConsolidadoParametrizacionMS {
  general?: Array<ConsolidadoGeneralMLS>;
  correo?: Array<ConsolidadoGeneralMLS>;
  sesion?: Array<ConsolidadoGeneralMLS>;
  otp?: Array<ConsolidadoGeneralMLS>;
  claveDigital?: Array<ConsolidadoGeneralMLS>;
  operaciones?: Array<ConsolidadoGeneralMLS>;
  mensajes?: Array<ConsolidadoMensajesMLS>;
  transferenciaInternas?: Array<ConsolidadoTransferenciaMLS>;
  transferenciaExternas?: Array<ConsolidadoTransferenciaMLS>;
}
